import axios, { AxiosResponse } from 'axios';
import apiPaths from 'enums/apiPaths';

export interface IZadost {
    token: string;
}

export interface IZadostData {
    idzadosti?: string;
    jmeno?: string;
    prijmeni?: string;
    email?: string;
    telefon?: string;
    datum?: string;
    stav?: ['IDEN', 'ZAPLA', 'CEKA', 'ZPRAC', 'VYPR'];
    code?: number;
    message?: string;
    ucet?: string;
}

const zadostApi = (token: string) => {
    return axios({
        method: 'GET',
        url: apiPaths.ZADOST,
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then((resp: AxiosResponse<IZadostData>) => resp.data);
};

export default zadostApi;
